export default {
  type: 'my_review_email',
  name: 'Email List',
  save: {
    fields: [
      'nameList',
      { field: 'emailList', required: true },
      'statusList',
      'topicsList',
      'listAliases',
      'active',
      { field: 'active', alias: 'origActive' },
      'servicenow',
      'groupRecords',
      'subscriberRecords'
    ],
    key: ['emailList']
  },
  load: {
    key: 'emailListWithSubscriberByEmailList'
  },
  form: {
    editHeader: 'Review Email List - ${nameList}',
    redirects: false,
    print: false,
    schema: [
      {
        name: 'origActive',
        type: 'hidden'
      },
      [
        {
          name: 'nameList',
          label: 'List Name',
          required: true,
          labelWidth: 3,
          width: 6,
          readonly: true
        },
        {
          name: 'statusList',
          label: 'Type',
          labelWidth: 2,
          width: 6,
          type: 'select',
          options: [
            {
              value: 'armpublic',
              text: 'Non-Moderated (Public, no attachments)'
            },
            {
              value: 'armpublicattachments',
              text: 'Non-Moderated (Public, allow attachments)'
            },
            {
              value: 'armprivate',
              text: 'Non-Moderated (Members Only)'
            },
            {
              value: 'armmoderated',
              text: 'Moderated'
            }
          ]
        }
      ],
      {
        name: 'topicsList',
        label: 'Description',
        labelWidth: 2
      },
      {
        name: 'listAliases',
        label: 'Aliases',
        labelWidth: 2
      },
      [
        {
          name: 'active',
          type: 'checkbox',
          width: 6,
          labelWidth: 4
        },
        {
          name: 'servicenow',
          label: 'ServiceNow',
          type: 'checkbox',
          width: 6,
          labelWidth: 4
        }
      ],
      {
        name: 'groupRecords',
        label: 'Groups',
        labelWidth: 12,
        type: 'results',
        fields: [
          {
            key: 'groupId',
            sortable: true,
            required: true
          },
          {
            key: 'groupName',
            label: 'Name',
            sortable: true,
            required: true
          },
          {
            key: 'groupDescription',
            label: 'Description',
            sortable: true
          },
          {
            key: 'selected',
            label: 'Remove'
          }
        ]
      },
      {
        name: 'subscriberRecords',
        label: 'Subscribers',
        labelWidth: 12,
        type: 'results',
        fields: [
          {
            key: 'personId',
            sortable: true,
            required: true
          },
          {
            key: 'fullName',
            label: 'Name',
            sortable: true,
            required: true
          },
          {
            key: 'affiliation',
            sortable: true
          },
          {
            key: 'userSubscriber',
            label: 'Email',
            sortable: true,
            required: true
          },
          {
            key: 'selected',
            label: 'Remove'
          }
        ]
      },
      {
        name: 'addSubscirbers',
        type: 'graphql_form_search_multi',
        fields: [
          {
            key: 'personId',
            sortable: true,
            required: true
          },
          {
            key: 'fullName',
            label: 'Name',
            sortable: true
          },
          {
            key: 'affiliation',
            sortable: true
          },
          {
            key: 'email',
            sortable: true
          },
          {
            key: 'remove'
          }
        ],
        formType: 'people',
        multiHeader: 'Added ${fullName} to email list',
        addLabel: 'Add Subscriber',
        searchFilters: {
          statusCode: {
            in: {
              type: 'StringArray',
              array: true,
              required: true,
              default: '["A", "M", "F"]'
            }
          }
        },
        message:
          'If you are trying to add a new or transition an ARM staff member, please use the New ARM Staff tab on the main review page.  Otherwise if you cannot find the person you are trying to add, please add them to the "Other Changes" below with contact information.'
      },
      {
        name: 'other',
        label: 'Other Changes',
        labelWidth: 2,
        type: 'textarea'
      },
      {
        type: 'message',
        message:
          'By requesting changes to this inactive email list you will also be requesting that the list be re-activated.',
        showIf: {
          field: 'origActive',
          value: false
        }
      }
    ],
    submitLabel: 'Submit Change Request'
  }
}
